import React from "react";

export default function LabelText({
  label,
  value,
  style,
  columnMode,
  valueStyle,
  labelStyle = { fontWeight: 700 },
  bottomDivider,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: columnMode ? "column" : "row",
        borderBottom: bottomDivider && "1px solid #77777720",
        margin: bottomDivider && "10px 0px",
        padding: bottomDivider && "10px 0px",
        ...style,
      }}
    >
      <div style={labelStyle}>
        <span>{label}</span>
      </div>
      <div style={valueStyle}>{value}</div>
    </div>
  );
}
